import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';

export const putNewAddress = async (address) => {
  const { token, userID } = useCurrentUser();
  const apiURL = `${API_HOST}/addresses/update_user_location`;
  // console.log('here is the apiURL: ', apiURL);

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'x-dqpn-user-id': userID,
  };

  try {
    const response = await axios.put(apiURL, address, { headers });
    return response;
  } catch (error) {
    console.error('Exception occurred while updating address:', error.message);
    return null;
  }
};
